import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import TableContainer from "../../../components/layout/table-container/table-container";
import TablePagination from "../../../components/Pagination/tablePagination";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loaderSpinningContainer";
import { useNavigate } from "react-router-dom";
import ChaptersListTableData from "./chapter-list-table-data";
import { chaptersList } from "../../../redux/actions/ffTrainingAction";
import NumberPagination from "../../../components/Pagination/number-pagination";

const ChapterListTable = ({ search, page_no }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [chaptersListData, setchaptersListData] = useState([]);
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [loading, setLoading] = useState(false);
  const [catchedErrorPopup, setCatchedErrorPopup] = useState(false);
  const [catchedErrorMsg, setCatchedErrorMsg] = useState();

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(chaptersList({ search, page }, onSuccess, onError));
  }, [page, search]);

  const fetchChaptersList = () => {
    dispatch(chaptersList({ search, page }, onSuccess, onError));
  };

  const onSuccess = (data) => {
    setLoading(false);
    setchaptersListData(data.data.data);
  };

  const closeCatchedErrPopup = () => {
    setCatchedErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    setCatchedErrorPopup(true);
    setCatchedErrorMsg(err.data.message);
  };

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <TableContainer>
        <thead>
          <tr className="table-rows color_747f9e">
            <th className="table-heads " width={"4%"}>
              #
            </th>
            <th className="table-heads " width={"18%"}>
              Chapter ID
            </th>
            <th className="table-heads " width={"18%"}>
              Chapter Name
            </th>
            <th className="table-heads " width={"18%"}>
              Priority
            </th>
            <th className="table-heads " width={"22%"}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody style={{ position: "relative" }}>
          {loading == true ? (
            <div className="list-spinner-container">
              <LoadingSpinnerTable show={loading} />
            </div>
          ) : chaptersListData?.chapters?.length > 0 ? (
            <>
              {chaptersListData?.chapters?.map((eachRow, index) => (
                <ChaptersListTableData
                  key={eachRow.id}
                  data={eachRow}
                  index={index}
                  fetchChaptersList={fetchChaptersList}
                  currentPage={chaptersListData?.pagination?.currentPage}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="1" className="text-center no-data-container fs_16">
                <span>~ No Data Found ~</span>
              </td>
            </tr>
          )}
        </tbody>
      </TableContainer>
      {chaptersListData?.pagination?.totalPages > 0 && (
        <NumberPagination
          setCurrentPage={setPage}
          pagination={chaptersListData?.pagination?.currentPage}
          totalPages={chaptersListData?.pagination?.totalPages}
          path={"/ff-training/chapters"}
          filters={`${queryString}`}
        />
      )}
      <ErrorPopup
        show={catchedErrorPopup}
        title={catchedErrorMsg}
        handleClose={closeCatchedErrPopup}
      />
    </>
  );
};

export default ChapterListTable;
